

export const filterList = [

  {
    id: 1,
    name: "Medium Name",
    value: "name",
  },
  {
    id: 2,
    name: "Medium email",
    value: "email",
  },
  {
    id: 3,
    name: "Blocked By",
    value: "blocked_by",
  },
  
  {
    id:7,
    name:'Dates',
    value:'created_at',
  }

];
